import i18next from "src/i18n/config";
import RouteService from "src/services/routeService";
import { invalidateOnSuccess, transformErrorResponse } from "src/store/helpers";
import { ApiResponse } from "src/types";

import { AdminBuilder } from "./tags";

const oauthClients = (builder: AdminBuilder) => ({
    getOauthClients: builder.query<API.OauthClient[], void>({
        providesTags: ["OauthClients"],
        transformErrorResponse: (err) =>
            transformErrorResponse(err, i18next.t("pages:adminOauthClientsPage.toast.oauthClientsFetchError")),
        transformResponse: (response: ApiResponse<API.OauthClient[]>) => response.model,
        query: async () => ({ url: await RouteService.getAdminClientsRoute() }),
    }),

    getOauthClient: builder.query<API.OauthClient, string>({
        providesTags: ["OauthClients"],
        transformErrorResponse: (err) =>
            transformErrorResponse(err, i18next.t("pages:adminOauthClientsPage.toast.oauthClientFetchError")),
        transformResponse: (response: ApiResponse<API.OauthClient>) => response.model,
        query: async (clientId) => {
            const base = await RouteService.getAdminClientsRoute();
            return { url: `${base}${clientId}` };
        },
    }),

    createOauthClient: builder.mutation<API.OauthClient, API.OauthClient>({
        invalidatesTags: invalidateOnSuccess("OauthClients"),
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        transformResponse: (response: ApiResponse<API.OauthClient>) => response.model,
        query: async (client) => ({ url: await RouteService.getAdminClientsRoute(), method: "POST", data: client }),
    }),

    updateOauthClient: builder.mutation<API.OauthClient, { clientId: string; client: API.OauthClient }>({
        invalidatesTags: invalidateOnSuccess("OauthClients"),
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        transformResponse: (response: ApiResponse<API.OauthClient>) => response.model,
        query: async ({ clientId, client }) => {
            const base = await RouteService.getAdminClientsRoute();
            return { url: `${base}${clientId}`, method: "PATCH", data: client };
        },
    }),

    deleteOauthClient: builder.mutation<API.OauthClient, string>({
        invalidatesTags: invalidateOnSuccess("OauthClients"),
        transformErrorResponse: (err) =>
            transformErrorResponse(err, i18next.t("pages:adminOauthClientsPage.toast.oauthClientDeleteError")),
        transformResponse: (response: ApiResponse<API.OauthClient>) => response.model,
        query: async (clientId) => {
            const base = await RouteService.getAdminClientsRoute();
            return { url: `${base}${clientId}`, method: "DELETE" };
        },
    }),
});

export default oauthClients;
